class CustomProductSlider extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
  }

  connectedCallback() {
    setTimeout(() => {
      this.initSliderLogic();
    }, 0);
  }

  initSliderLogic() {
    const pagination = this.querySelector('.product-slider__bottom-nav .slider__pagination');
    const blockTypes = this.querySelectorAll('.product-slider__block-types span');
    const progressDot = this.querySelector('.product-slider__progress-dot');

    if (!pagination || blockTypes.length === 0 || !progressDot) return;

    blockTypes[0].classList.add('is-active');

    this.observer = new MutationObserver(() => {
      const dots = pagination.children;
      const dotPositionDiff = parseInt(100 / (dots.length - 1));

      Array.from(dots).forEach((dot, index) => {
        if (dot.classList.contains('active')) {
          blockTypes.forEach(span => span.classList.remove('is-active'));

          if (blockTypes[index]) {
            blockTypes[index].classList.add('is-active');

            let calculatedPosition, subtractPixels = 0;
            if (index === 0) {
              calculatedPosition = dotPositionDiff * index;
              subtractPixels = 0;
            } else if (index > 0 && index < dots.length - 1) {
              calculatedPosition = dotPositionDiff * index;
              subtractPixels = 10;
            } else {
              calculatedPosition = dotPositionDiff * index;
              subtractPixels = 20;
            }

            progressDot.style.left = `calc(${calculatedPosition}% - ${subtractPixels}px)`;

            const sliderType = blockTypes[index].dataset.sliderType;
            const productTitle = blockTypes[index].dataset.productTitle;

            const clevertapData = {
              Slider_Type: sliderType,
              Product_Name: productTitle
            };

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              event: "Product_Slider",
              Slider_Type: sliderType,
              Product_Name: productTitle,
              clevertap: clevertapData
            });
          }
        }
      });
    });

    this.observer.observe(pagination, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('custom-product-slider', CustomProductSlider);